import Vue from 'vue';

export default Vue.component('captcha-svg', {
  template: require('./template.html'),
  computed: {
    imageColor() {
      return this.droplet.captchaLetters || this.defaultLetters;
    },
  },
  props: ['droplet'],
  data() {
    return {
      defaultLetters: '#444',
    };
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/components/captcha-svg/index.js